import React from 'react';
import classnames from 'classnames';
import styles from './styles.mod.scss';

export default function Input({ ariaLabel, className, ...props }) {
  return (
    <input
      aria-label={ariaLabel}
      className={classnames(styles.input, className)}
      {...props}
    />
  );
}
